import { useEffect, useState } from 'react';

import CardComponent from '../../../../components/base/CardComponent';
import { Spinner } from 'react-bootstrap';
import { ReactComponent as PDFIcon } from '../../../../assets/img/file-PDF.svg';
import { Link, useParams } from 'react-router-dom';
import { getLegalDocuments } from '../../../../api/service/superAdmin/personal-clients/service';
import { IPersonalClientLegalDocuments } from '../../../../api/service/superAdmin/personal-clients/types';
import { openExternalLink } from '../../../../util';

export const Legal = () => {
  const [legalDocs, setLegalDocs] = useState<IPersonalClientLegalDocuments[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();

  const fetchAllDocuments = async () => {
    try {
      setIsLoading(true);
      const docs = await getLegalDocuments(id);
      setLegalDocs(docs);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAllDocuments();
  }, []);

  return (
    <>
      <CardComponent>
        {isLoading ? (
          <Spinner />
        ) : (
          <div className="table-responsive react-bootstrap-table">
            <table className="table table-hover table-condensed">
              <tbody className="remote-table-body">
                {legalDocs?.map((item) => {
                  return (
                    <tr key={item._id}>
                      <td>
                        <div className="d-flex align-items-center">
                          <span className="pdf-icon">
                            <PDFIcon />
                          </span>
                          <Link
                            to={item.document[0].path}
                            onClick={(e) => openExternalLink(item.document[0].path, { event: e })}
                            target="_blank"
                            rel="noreferrer"
                            className="fs-h3 ms-2 font-link"
                          >
                            {item.document[0].name}
                          </Link>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </CardComponent>
    </>
  );
};
